import request from '@/utils/request'

export function Add(data) {
  return request({
    url: '/api/User/Add',
    method: 'post',
    data
  })
}

export function Update(data) {
  return request({
    url: '/api/User/Update',
    method: 'post',
    data
  })
}

export function UpdatePower(data) {
  return request({
    url: '/api/User/UpdatePower',
    method: 'Get',
    params:data
  })
}



export function UpdatePwd(data) {
  return request({
    url: '/api/User/UpdatePwd',
    method: 'post',
    data
  })
}

export function Delete(data) {
  return request({
    url: '/api/User/Delete',
    method: 'get',
    params:data
  })
}
export function GetPage(data) {
  return request({
    url: '/api/User/GetPage',
    method: 'get',
    params:data
  })
}
export function GetList() {
  return request({
    url: '/api/User/GetList',
    method: 'get'
  })
}




